!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.dz = t());
}(this, function () {
  "use strict";

  return [{
    locale: "dz",
    pluralRuleFunction: function (e, t) {
      return "other";
    },
    fields: {
      year: {
        displayName: "ལོ",
        relative: {
          0: "this year",
          1: "next year",
          "-1": "last year"
        },
        relativeTime: {
          future: {
            other: "ལོ་འཁོར་ {0} ནང་"
          },
          past: {
            other: "ལོ་འཁོར་ {0} ཧེ་མ་"
          }
        }
      },
      "year-short": {
        displayName: "ལོ",
        relative: {
          0: "this year",
          1: "next year",
          "-1": "last year"
        },
        relativeTime: {
          future: {
            other: "ལོ་འཁོར་ {0} ནང་"
          },
          past: {
            other: "ལོ་འཁོར་ {0} ཧེ་མ་"
          }
        }
      },
      month: {
        displayName: "ཟླ་ཝ་",
        relative: {
          0: "this month",
          1: "next month",
          "-1": "last month"
        },
        relativeTime: {
          future: {
            other: "ཟླཝ་ {0} ནང་"
          },
          past: {
            other: "ཟླཝ་ {0} ཧེ་མ་"
          }
        }
      },
      "month-short": {
        displayName: "ཟླ་ཝ་",
        relative: {
          0: "this month",
          1: "next month",
          "-1": "last month"
        },
        relativeTime: {
          future: {
            other: "ཟླཝ་ {0} ནང་"
          },
          past: {
            other: "ཟླཝ་ {0} ཧེ་མ་"
          }
        }
      },
      day: {
        displayName: "ཚེས་",
        relative: {
          0: "ད་རིས་",
          1: "ནངས་པ་",
          2: "གནངས་ཚེ",
          "-2": "ཁ་ཉིམ",
          "-1": "ཁ་ཙ་"
        },
        relativeTime: {
          future: {
            other: "ཉིནམ་ {0} ནང་"
          },
          past: {
            other: "ཉིནམ་ {0} ཧེ་མ་"
          }
        }
      },
      "day-short": {
        displayName: "ཚེས་",
        relative: {
          0: "ད་རིས་",
          1: "ནངས་པ་",
          2: "གནངས་ཚེ",
          "-2": "ཁ་ཉིམ",
          "-1": "ཁ་ཙ་"
        },
        relativeTime: {
          future: {
            other: "ཉིནམ་ {0} ནང་"
          },
          past: {
            other: "ཉིནམ་ {0} ཧེ་མ་"
          }
        }
      },
      hour: {
        displayName: "ཆུ་ཚོད",
        relative: {
          0: "this hour"
        },
        relativeTime: {
          future: {
            other: "ཆུ་ཚོད་ {0} ནང་"
          },
          past: {
            other: "ཆུ་ཚོད་ {0} ཧེ་མ་"
          }
        }
      },
      "hour-short": {
        displayName: "ཆུ་ཚོད",
        relative: {
          0: "this hour"
        },
        relativeTime: {
          future: {
            other: "ཆུ་ཚོད་ {0} ནང་"
          },
          past: {
            other: "ཆུ་ཚོད་ {0} ཧེ་མ་"
          }
        }
      },
      minute: {
        displayName: "སྐར་མ",
        relative: {
          0: "this minute"
        },
        relativeTime: {
          future: {
            other: "སྐར་མ་ {0} ནང་"
          },
          past: {
            other: "སྐར་མ་ {0} ཧེ་མ་"
          }
        }
      },
      "minute-short": {
        displayName: "སྐར་མ",
        relative: {
          0: "this minute"
        },
        relativeTime: {
          future: {
            other: "སྐར་མ་ {0} ནང་"
          },
          past: {
            other: "སྐར་མ་ {0} ཧེ་མ་"
          }
        }
      },
      second: {
        displayName: "སྐར་ཆཱ་",
        relative: {
          0: "now"
        },
        relativeTime: {
          future: {
            other: "སྐར་ཆ་ {0} ནང་"
          },
          past: {
            other: "སྐར་ཆ་ {0} ཧེ་མ་"
          }
        }
      },
      "second-short": {
        displayName: "སྐར་ཆཱ་",
        relative: {
          0: "now"
        },
        relativeTime: {
          future: {
            other: "སྐར་ཆ་ {0} ནང་"
          },
          past: {
            other: "སྐར་ཆ་ {0} ཧེ་མ་"
          }
        }
      }
    }
  }];
});